import ShoppingCart from './shopping-cart';
import ProductsShoppingCart from './products-cart';

const $ = window.jQuery;

class Products {
  constructor(selectors, volumeRange, shoppingCart, filterCombos) {
    this.selectors = selectors;
    this.shoppingCart = shoppingCart;

    this.filterCombos = filterCombos;

    this.productsShoppingCart = new ProductsShoppingCart(this.selectors, this.shoppingCart);
    
    this.productResults = $(selectors.container);
    this.noProducts = $(selectors.noProducts);
    this.textInput = $(selectors.textInput);
    
    // this.sizeTypeSelect = $(selectors.sizeTypeSelector);
    this.containerTypeSelect = $(selectors.containerTypeSelector);

    this.wasteTypeSelect = $(selectors.wasteTypeSelector);
    this.productTypeCheckboxes = $(selectors.productTypeSelector);

    this.filterOptionsSelect = $(selectors.filterOptions);

    this.resetFilterButton = $(selectors.resetFilterButtonSelector);

    this.startToAddButtons = $(selectors.startToAdd);
    this.closeAddButtons = $(selectors.closeAddButtons);
    this.closeMoreInfoButtons = $(selectors.closeMoreInfoButtons);
    this.moreInfoButtons = $(selectors.moreInfo);
    this.volumeDropdowns = $(selectors.volumeDropdowns);
   
    this.scrollOffset = 100;
  }

  init() {
    this.productsShoppingCart.initializeShoppingCartProducts();
    this.productsShoppingCart.initializeClickHandlers();

    this.createSearchFilter();
    this.initWastTypeFilter();
    this.initializeClickHandlers();
  }

  initializeClickHandlers() {
    this.startToAddButtons.on('click', (e) => {
      const button = $(e.currentTarget);

      const product = button.parentsUntil('.product').parent();
      product.addClass('selected');

      const moreInfo = product.find('.more-info');
      
      if (moreInfo.is(':visible')) {
        $('html, body').animate({
          scrollTop: product.offset().top - this.scrollOffset,
        }, () => {
          moreInfo.fadeOut(200);
          product.find('.add-to-cart').fadeIn(200);
        });
      } else {
        product.find('.add-to-cart').fadeIn(200);
      }

      product.find('.buttons-initial').hide();
    });

    this.closeAddButtons.on('click', (e) => {
      const button = $(e.currentTarget);

      const product = button.parentsUntil('.product').parent();

      product.find('.add-to-cart').fadeOut(200, () => {
        product.removeClass('selected');
        product.find('.buttons-initial').fadeIn();
      });
    });

    this.closeMoreInfoButtons.on('click', (e) => {
      const button = $(e.currentTarget);

      const product = button.parentsUntil('.product').parent();

      $('html, body').animate({
        scrollTop: product.offset().top - this.scrollOffset,
      }, () => {
        product.find('.more-info').fadeOut(200, () => {
          product.removeClass('selected');
          product.find('.buttons-initial').fadeIn();
        });
      });
    });

    this.moreInfoButtons.on('click', (e) => {
      const button = $(e.currentTarget);
      const product = button.parentsUntil('.product').parent();
      product.addClass('selected');

      product.find('.more-info').fadeIn(200);
      product.find('.buttons-initial').hide();
    });

    this.volumeDropdowns.change((e) => {
      const dropdown = $(e.currentTarget);
      const imageUrl = dropdown.find('option:selected').data('image-src');
      const product = dropdown.parentsUntil('.product').parent();

      const imageNode = product.find('.image-container img');
      imageNode.fadeOut(50, () => {
        imageNode.attr('src', imageUrl);
        imageNode.fadeIn(250);
      });
    });
  }

  createSearchFilter() {
    this.textInput.keyup(() => {
      this.updateProductList();
    });

    this.wasteTypeSelect.change((e) => {
      this.updateFilterOptions(e);
      this.updateProductList();
    });

    this.containerTypeSelect.change(() => {
      this.updateProductList();
    });
  }

  initWastTypeFilter() {
    const selectedOption = this.wasteTypeSelect.children('option:selected');

    if (selectedOption && selectedOption.length > 0) {
      this.updateProductList();
    }
  }

  updateProductList() {
    let filtered = false;

    const allProducts = this.productResults.children('[data-keywords]');
    let matchingProducts = allProducts;

    let keyword = this.textInput.val();

    const selectedWasteType = this.wasteTypeSelect.val();
    const selectedContainerType = this.containerTypeSelect.val();

    const filterIds = [];
    
    // this.updateFilterOptions(selectedWasteType, selectedContainerType, selectedSizeType);

    if (keyword && keyword.length > 1) {
      keyword = keyword.toLowerCase();
      matchingProducts = matchingProducts.filter(`[data-keywords*='${keyword}']`);
      filtered = true;
    }

    if (selectedWasteType && selectedWasteType !== 'default') {
      matchingProducts = matchingProducts.filter(`[data-waste-type*=';${selectedWasteType};']`);
      filtered = true;
      filterIds.push(selectedWasteType);
    }

    if (selectedContainerType && selectedContainerType !== 'default') {
      matchingProducts = matchingProducts.filter(`[data-product-type*=';${selectedContainerType};']`);
      filtered = true;
      filterIds.push(selectedContainerType);
    }

    this.noProducts.hide();

    if (filtered) {
      allProducts.hide();
      matchingProducts.show();
      if (matchingProducts.length === 0) {
        this.noProducts.show();
      }
    } else {
      allProducts.show();
    }
  }

  static includeProductBasedOnVolume(products, index, min, max) {
    const volumesString = $(products[index]).data('volumes');

    if (!volumesString) {
      return false;
    }

    const volumes = volumesString.toString().indexOf(';') > -1 ? volumesString.split(';') : [volumesString];

    for (let x = 0; x < volumes.length; x += 1) {
      if (volumes[x] >= min && volumes[x] <= max) {
        return true;
      }
    }

    return false;
  }

  static includeProductBasedOnProductType(products, index, selectedProductTypes) {
    for (let x = 0; x < selectedProductTypes.length; x += 1) {
      if ($(products[index]).data('product-type') === parseInt(selectedProductTypes[x].value, 10)) {
        return true;
      }
    }

    return false;
  }

  updateFilterOptions(e = false) {
    const filterCombos = global.filterCombos; /* eslint-disable-line prefer-destructuring */
    this.containerTypeSelect.find('option').attr('disabled', true);
    
    if (e) {
      this.containerTypeSelect.val('default');
      const value = $(e.currentTarget).val();
      if (value === 'default') {
        this.containerTypeSelect.find('option').attr('disabled', false);
        return;
      }

      let selector = '';
      filterCombos[value].product_type.forEach((val) => {
        selector += `[value='${val}'], `;
      });

      selector += "[value='default']";

      if (filterCombos[value].product_type.length) {
        this.containerTypeSelect.find(selector).attr('disabled', false);
        if (filterCombos[value].product_type.length === 1) {
          this.containerTypeSelect.val(filterCombos[value].product_type[0]);
          this.containerTypeSelect.find("[value='default']").attr('disabled', true);
        }
        return;
      }
    }

    this.containerTypeSelect.find('option').attr('disabled', false);
  }
}

$(document).ready(() => {
  const shoppingCart = new ShoppingCart();

  const products = new Products({
    volumeRange: {
      sliderId: 'volume-range-slider',
      minId: 'volume-range-slider-min',
      maxId: 'volume-range-slider-max',
    },
    container: '.product-list .products',
    textInput: '#product-search-input',
    sizeTypeSelector: '.size-type-filter',
    containerTypeSelector: '.container-type-filter',
    wasteTypeSelector: '.waste-type-filter',
    productTypeSelector: '.product-type-filter',
    filterOptions: '.product-filters .filter option',
    noProducts: '.no-products-found',
    startToAdd: '.btn-start-to-add',
    volumeDropdowns: 'select.volume',
    closeAddButtons: '.btn-close-add',
    closeMoreInfoButtons: '.btn-close-more-info',
    moreInfo: '.btn-more-info',
    addToShoppingCartButtons: '.btn-add-to-shopping-cart',
    shoppingCartProducts: '.shopping-cart-products',
    noProductsInCart: '.no-products',
    goToFormButton: '.btn-go-to-form',
    resetFilterButtonSelector: '.reset-filter-button',
  }, global.volumeRange, shoppingCart, window.filterCombos);

  products.init();
});
